import {
	DBType,
	RestAPI,
	IVIPUser,
	VIPUser,
	IRestCollectionParams,
	IRestResult,
	IRestParams,
	IRestDeleteParams,
	IVIPUserOptions,
	IEntityRest,
	staticImplements,
} from "@/loader";

export interface IVIPUserRestGetParams extends IRestParams {
	options?: IVIPUserOptions;
}

export interface IVIPUserRestCollectionParams extends IRestCollectionParams, IVIPUserRestGetParams {
}

@staticImplements<IEntityRest<IVIPUser, VIPUser>>()
export abstract class VIPUserRest {
	public static readonly endpoint: string = "users";

	public static getURL(data?: IVIPUser, singular: boolean = false): string {
		let url: string[] = [RestAPI.url.replace(/\/$/, ""), RestAPI.wpNamespace];
		url.push(VIPUserRest.endpoint);
		if (singular && data?.id) {
			url.push(data.id.toString());
		}
		return url.join("/");
	}

	public static async list(params: IVIPUserRestCollectionParams = {}): Promise<IRestResult<VIPUser>> {
		if (!params.context) {
			params.context = "edit";
		}
		return await RestAPI.list<IVIPUser, VIPUser>(VIPUserRest.getURL(), DBType.users, params);
	}

	public static async get(data: IVIPUser, params: IVIPUserRestGetParams = {}): Promise<IRestResult<VIPUser>> {
		if (!params.context) {
			params.context = "edit";
		}
		return await RestAPI.get<IVIPUser, VIPUser>(VIPUserRest.getURL(data, true), DBType.users, params);
	}

	public static async create(data: IVIPUser): Promise<IRestResult<VIPUser>> {
		return await RestAPI.post<IVIPUser, VIPUser>(VIPUserRest.getURL(), data, DBType.users);
	}

	public static async update(data: IVIPUser): Promise<IRestResult<VIPUser>> {
		return await RestAPI.post<IVIPUser, VIPUser>(VIPUserRest.getURL(data, true), data, DBType.users);
	}

	public static async delete(data: IVIPUser, params?: IRestDeleteParams): Promise<IRestResult<VIPUser>> {
		return await RestAPI.delete<IVIPUser, VIPUser>(VIPUserRest.getURL(data, true), DBType.users, params);
	}
}
